import clsx from 'clsx';
import Ripples from 'react-ripples';

export default function RippleCard({
  className,
  children,
  onClick,
}: {
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}) {
  const Comp = Ripples as any;
  return (
    <Comp
      onClick={() => {
        if (onClick) onClick();
      }}
      placeholder=""
      className={clsx('cursor-pointer', className)}
    >
      {children}
    </Comp>
  );
}
